<template>
  <div>
    <Head title="បង្កើតកម្ចី" />
    <h1 class="moul flex items-center mb-8 text-2xl">
      <Link class="flex items-center text-indigo-400 hover:text-indigo-600" href="/loans"><CurrencyDollarIcon class="mr-2 w-8 h-8" /> កម្ចី</Link>
      <span class="text-indigo-400 font-medium"><ChevronRightIcon class="w-5 h-5" /></span> បង្កើតថ្មី
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8">
          <div class="w-full mb-4">
            <p><span class="font-medium moul">ព័ត៌មានអតិថិជន</span> <span class="text-sm text-red-500">(វាយឈ្មោះ ឬ ID សម្រាប់អតិថិជនចាស់)</span></p>
            <hr>
          </div>

          <div class="relative pr-6 w-full lg:w-1/4">
            <text-input v-model="form.customer_id" @keydown="handleCustomer($event)" :error="form.errors.customer_id" class="w-full" @blur="resetSuggestions($event)" placeholder="វាយឈ្មោះ អតិថិជនដែលមានស្រាប់" label="ឈ្មោះពេញអិតិថិជន *" />
            <div v-if="this.suggested_customers.length > 0" style="position: absolute; z-index: 100" class="autocomplete-dropdown absolute z-10 -mt-8 w-full bg-white border rounded shadow-lg">
              <div v-for="suggest in this.suggested_customers" :key="suggest.id" class="p-2 text-indigo-600 hover:bg-gray-100 cursor-pointer" @click="setCustomer(suggest)">{{ suggest.customer_id }} - {{ suggest.fullname }}</div>
            </div>
          </div>

          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/4" label="នាមត្រកូល *" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/4" label="នាមខ្លួន *" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/4" label="លេខទូរសព្ទ" />
          <div class="relative pr-6 w-full lg:w-1/4">
            <textarea-input @keydown="handleAddress($event)" autocomplete="on" v-model="form.address" :error="form.errors.address" class="w-full" label="អាសយដ្ឋាន" />
            <div v-if="this.suggested_address.length > 0" style="position: absolute; z-index: 100" class="autocomplete-dropdown absolute z-10 -mt-8 w-full bg-white border rounded shadow-lg">
              <div v-for="suggest in this.suggested_address" :key="suggest.address" class="p-2 text-indigo-600 hover:bg-gray-100 cursor-pointer" @click="setAddress(suggest.address)">{{ suggest.address }}</div>
            </div>
          </div>

          <!-- <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/4" label="ខេត្ត/ក្រុង" /> -->
          <div class="w-full my-4">
            <p><span class="font-medium moul">ព័ត៌មានអំពីកម្ចី</span></p>
            <hr>
          </div>
          <select-input v-model="form.officer_id" :error="form.errors.officer_id" class="pb-8 pr-6 w-full lg:w-1/4" label="មន្ត្រី​ឥណទាន *">
            <option :value="null">ជ្រើសរើស</option>
            <option v-for="user in users" :key="user.id" :value="user.id">{{ user.first_name }} {{ user.last_name }}</option>
          </select-input>
          <text-input v-model="form.loan_id" :error="form.errors.loan_id" class="pb-8 pr-6 w-full lg:w-1/4" label="ID កម្ចី *" />
          
          <select-input v-model="form.loan_type" :error="form.errors.loan_type" class="pb-8 pr-6 w-full lg:w-1/4" label="ប្រភេទកម្ចី *">
            <option :value="null">ជ្រើសរើស</option>
            <option value="1">បង់ថយ</option>
            <option value="2">បង់ថេរ</option>
          </select-input>

          <text-input v-model="form.amount" type="number" step="0.01" :error="form.errors.amount" class="pb-8 pr-6 w-full lg:w-1/4" label="ទឹកប្រាក់ *" />
          <select-input v-model="form.currency" :error="form.errors.currency" class="pb-8 pr-6 w-full lg:w-1/4" label="រូបបិយបណ្ណ *">
            <option :value="null">ជ្រើសរើស</option>
            <option value="រៀល">រៀល</option>
            <option value="USD">USD</option>
          </select-input>

          <text-input v-model="form.interest_rate" type="number" step="0.01" :error="form.errors.interest_rate" class="pb-8 pr-6 w-full lg:w-1/4" label="អត្រាការប្រាក់ (%) *" />
          <text-input v-model="form.term" type="number" step="1" :error="form.errors.term" class="pb-8 pr-6 w-full lg:w-1/4" label="រយៈពេល *" />
          <select-input v-model="form.term_period" :error="form.errors.term_period" class="pb-8 pr-6 w-full lg:w-1/4" label="រយៈពេលកំណត់ជា *">
            <option :value="null">ជ្រើសរើស</option>
            <option value="+1 day">ថ្ងៃ</option>
            <option value="+1 week">សប្តាហ៍</option>
            <option value="+2 weeks">កន្លះខែម្តង</option>
            <option value="+1 month">ខែ</option>
          </select-input>

          <text-input v-model="form.applied_date" :error="form.errors.applied_date" type="date" class="pb-8 pr-6 w-full lg:w-1/4" label="កាលបរិច្ឆេទអនុម័ត *" />
          <text-input v-model="form.first_payment_date" :error="form.errors.first_payment_date" type="date" class="pb-8 pr-6 w-full lg:w-1/4" label="កាលបរិច្ឆេទបង់ប្រាក់ដំបូង *" />

          <text-input v-model="form.late_payment_penalties" type="number" :error="form.errors.late_payment_penalties" class="pb-8 pr-6 w-full lg:w-1/4" label="ពិន័យ (រៀល/ថ្ងៃ បើយឺតជាង៣ថ្ងៃ)" />
          <text-input v-model="form.service_fee" type="number" step="0.01" :error="form.errors.service_fee" class="pb-8 pr-6 w-full lg:w-1/4" label="សេវាកម្មប្រ/តិ និងរដ្ឋបាល (%) *" />
          <text-input v-model="form.guarantor" :error="form.errors.guarantor" class="pb-8 pr-6 w-full lg:w-1/4" label="ឈ្មោះអ្នកធានាទី១" />
          <text-input v-model="form.guarantor_2" :error="form.errors.guarantor_2" class="pb-8 pr-6 w-full lg:w-1/4" label="ឈ្មោះអ្នកធានាទី២" />
          <textarea-input v-model="form.remarks" :error="form.errors.remarks" class="pb-8 pr-6 w-full lg:w-1/4" label="កំណត់សម្គាល់" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">បង្កើតឥឡូវនេះ</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import { CurrencyDollarIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    CurrencyDollarIcon,
    ChevronRightIcon,
  },
  layout: Layout,
  props: {
    users: Array,
    generated_id: String,
    generated_customer_id: String,
  },
  remember: 'form',
  data() {
    return {
      suggested_address: [],
      suggested_customers: [],
      form: this.$inertia.form({
        customer_id: this.generated_customer_id,
        first_name: '',
        last_name: '',
        phone: '',
        address: '',
        city: '',
        guarantor: '',
        guarantor_2: '',
        borrower_id: null,
        loan_id: this.generated_id,
        loan_type: null,
        amount: null,
        currency: 'រៀល',
        interest_rate: null,
        term: null,
        term_period: null,
        applied_date: null,
        first_payment_date: null,
        late_payment_penalties: 0,
        service_fee: null,
        remarks: null,
        officer_id: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/loans')
    },
    resetSuggestions(e) {
      this.handleCustomerID(e)
    },
    handleCustomer(e) {
      this.suggested_customers = []
      if (e.target.value.length > 2) {
        axios
          .get('/contacts/find_customers', {
            params: {
              name: e.target.value,
            },
          })
          .then((response) => {
            this.suggested_customers = []
            if (Object.keys(response.data).length !== 0) {
              this.suggested_customers = response.data
            }
          })
      }
    },
    setCustomer(suggest) {
      this.form.customer_fullname = suggest.fullname
      this.form.customer_id = suggest.customer_id
      this.handleCustomerID(suggest)
      this.suggested_customers = []
    },
    handleCustomerID(e) {
      axios
        .get('/loans/customer', {
          params: {
            customer_id: this.form.customer_id ? this.form.customer_id : e.target.value,
          },
        })
        .then((response) => {
          this.form.first_name = null
          this.form.last_name = null
          this.form.phone = null
          this.form.address = null
          this.form.city = null
          this.form.borrower_id = null
          if (Object.keys(response.data).length !== 0) {
            this.form.first_name = response.data.first_name
            this.form.last_name = response.data.last_name
            this.form.phone = response.data.phone
            this.form.address = response.data.address
            this.form.city = response.data.city
            this.form.borrower_id = response.data.id
            this.suggested_customers = []
          }
        })
    },
    handleAddress(e) {
      this.suggested_address = []
      if (e.target.value.length > 2) {
        axios
          .get('/loans/find_address', {
            params: {
              address: e.target.value,
            },
          })
          .then((response) => {
            this.suggested_address = []
            if (Object.keys(response.data).length !== 0) {
              this.suggested_address = response.data
            }
          })
      }
    },
    setAddress(add) {
      this.form.address = add
      this.suggested_address = []
    },
  },
}
</script>
